import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';

export const templateActivityGrid = document.createElement('template');

templateActivityGrid.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>

    <div class="wrapper">
          <div class="content">
                <div class="grid">
                    <gz-grid-view class="grid-view">
                       <div class="header-buttons" slot="grid-header-actions-slot">
                            <gz-tooltip class="tooltip" id="tooltip-deleteAllActivitiesBtn" tooltipText="">
                                <gz-button id="deleteAllActivitiesBtn" type="outline" color="primary" lowercase="true" buttonfontsize="small" buttonHeight="small"></gz-button>
                            </gz-tooltip>
                       </div>
                       <div slot="no-results--additional-data">
                            <gz-text id="all-inv-files-are-displayed-here" fontSize="14"></gz-text>
                       </div>
                    </gz-grid-view>
                </div>
          </div>
      </div>
`;
